<template>
  <modal
    :is-open="isOpen"
    :title="title"
    size="md"
    :close-button="mode === 'manage'"
    :card-on-mobile="true"
    @close="$emit('cancel')"
  >
    <div class="devices-modal">
      <div v-if="mode === 'login'" class="devices-modal__subtitle">
        חרגת ממגבלת המכשירים המחוברים ({{ maxDevices }}). כדי להתחבר מהמכשיר
        הנוכחי יש לנתק אחד מהמכשירים הבאים:
      </div>

      <div v-if="!devices.length" class="devices-modal__empty">
        אין מכשירים מחוברים
      </div>

      <div
        v-for="device in devices"
        :key="device.id"
        class="devices-modal__item"
      >
        <div class="devices-modal__info">
          <div class="devices-modal__name">
            {{ deviceTitle(device) }}
            <span v-if="device.is_current" class="devices-modal__current">
              (המכשיר הנוכחי)
            </span>
          </div>
          <div class="devices-modal__meta">
            <span
              >פעילות אחרונה: {{ formatDate(device.last_activity_at) }}</span
            >
            <span v-if="deviceLocation(device)">
              · {{ deviceLocation(device) }}
            </span>
          </div>
        </div>
        <div
          class="btn btn--border-grey devices-modal__disconnect"
          @click="onDisconnect(device)"
        >
          נתק מכשיר
        </div>
      </div>

      <div v-if="mode === 'login'" class="devices-modal__footer">
        <div class="btn btn--border-grey" @click="$emit('cancel')">ביטול</div>
      </div>
    </div>
    <!-- Disconnecting is one click and cannot be undone: always confirm -->
    <TheConfirm
      :is-shown="!!pendingDevice"
      title="אזהרה"
      :question="confirmQuestion"
      @ok="confirmDisconnect"
      @cancel="pendingDevice = null"
    />
  </modal>
</template>

<script>
import moment from 'moment';
import Modal from './Modal.vue';
import TheConfirm from '@/Components/Alerts/TheConfirm';

export default {
  name: 'DevicesModal',
  components: { Modal, TheConfirm },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    devices: {
      type: Array,
      default: () => []
    },
    maxDevices: {
      type: Number,
      default: 3
    },
    // login — модалка при превышении лимита на входе;
    // manage — список в личном деле (отключение любых устройств).
    mode: {
      type: String,
      default: 'login'
    }
  },
  data() {
    return {
      // device waiting for the user to confirm its disconnection
      pendingDevice: null
    };
  },
  computed: {
    title() {
      return this.mode === 'login' ? 'מגבלת מכשירים' : 'מכשירים מחוברים';
    },
    confirmQuestion() {
      if (!this.pendingDevice) {
        return '';
      }
      if (this.pendingDevice.is_current) {
        return 'זהו המכשיר הנוכחי שלך. ניתוק יגרום ליציאה מהמערכת. להמשיך?';
      }
      return (
        'האם לנתק את המכשיר "' +
        this.deviceTitle(this.pendingDevice) +
        '"? יהיה צורך להתחבר מחדש ממכשיר זה.'
      );
    }
  },
  methods: {
    deviceTitle(device) {
      const parts = [];
      if (device.device_type) {
        parts.push(device.device_type);
      }
      if (device.os) {
        parts.push(device.os);
      }
      if (device.browser) {
        parts.push(device.browser);
      }

      return parts.length ? parts.join(' · ') : 'מכשיר לא מזוהה';
    },
    deviceLocation(device) {
      const parts = [];
      if (device.city) {
        parts.push(device.city);
      }
      if (device.country) {
        parts.push(device.country);
      }

      return parts.join(', ');
    },
    formatDate(value) {
      return value ? moment(value).format('DD.MM.YYYY HH:mm') : '—';
    },
    onDisconnect(device) {
      this.pendingDevice = device;
    },
    confirmDisconnect() {
      const device = this.pendingDevice;
      this.pendingDevice = null;
      if (device) {
        this.$emit('disconnect', device);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.devices-modal {
  &__subtitle {
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 22px;
    color: #38455d;
  }

  &__empty {
    padding: 16px 0;
    text-align: center;
    color: #8b97ad;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 0;
    border-bottom: 1px solid #e6eaf0;

    &:last-of-type {
      border-bottom: none;
    }
  }

  &__info {
    flex: 1;
    min-width: 0;
    text-align: right;
    direction: rtl;
  }

  &__name {
    font-weight: 500;
    font-size: 14px;
    color: #38455d;
    text-align: right;
  }

  &__current {
    color: #409fff;
    font-weight: 400;
  }

  &__meta {
    margin-top: 2px;
    font-size: 12px;
    color: #8b97ad;
    text-align: right;
  }

  &__disconnect {
    white-space: nowrap;
    flex-shrink: 0;
    padding: 8px 16px;
    line-height: 20px;
  }

  &__footer {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
